// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"a29e031c","86":"ac442df2","272":"51d47876","283":"3b6d5537","453":"821fd3de","509":"0ec00735","773":"bdd394ab","778":"ec411908","780":"ee95fa06","831":"05dfbe6e","836":"155f4508","842":"332a5db8","953":"349bddcc"}[chunkId] + ".chunk.js";
};